import { useState } from "react";
import { View, Text, TouchableOpacity, KeyboardAvoidingView, Platform, ScrollView } from "react-native";
import { Link } from "expo-router";
import { Button } from "../../components/Button";
import { Input } from "../../components/Input";

const API_URL = (process.env.EXPO_PUBLIC_API_URL || "https://dashhound.app") + "/api";

export default function ForgotPasswordScreen() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit() {
    if (!email) {
      setError("Please enter your email");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || "Request failed");
      }
      setSent(true);
    } catch (err: any) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === "ios" ? "padding" : "height"}
      style={{ flex: 1, backgroundColor: "#f9fafb" }}
    >
      <ScrollView contentContainerStyle={{ flexGrow: 1, justifyContent: "center", padding: 24 }}>
        <View style={{ marginBottom: 40, alignItems: "center" }}>
          <Text style={{ fontSize: 36, fontWeight: "800", color: "#111827" }}>DashHound</Text>
          <Text style={{ fontSize: 16, color: "#6b7280", marginTop: 8 }}>Reset your password</Text>
        </View>

        {error ? (
          <View style={{ backgroundColor: "#fef2f2", padding: 12, borderRadius: 8, marginBottom: 16 }}>
            <Text style={{ color: "#dc2626", textAlign: "center" }}>{error}</Text>
          </View>
        ) : null}

        {sent ? (
          <View style={{ backgroundColor: "#f0fdf4", padding: 20, borderRadius: 12, alignItems: "center" }}>
            <Text style={{ fontSize: 18, fontWeight: "700", color: "#16a34a", marginBottom: 8 }}>Check your email</Text>
            <Text style={{ fontSize: 14, color: "#374151", textAlign: "center", lineHeight: 22 }}>
              If an account with that email exists, we've sent a password reset link. Check your inbox and spam folder.
            </Text>
          </View>
        ) : (
          <>
            <Text style={{ fontSize: 14, color: "#6b7280", marginBottom: 16, textAlign: "center", lineHeight: 22 }}>
              Enter the email you signed up with and we'll send you a link to reset your password.
            </Text>
            <Input
              label="Email"
              value={email}
              onChangeText={setEmail}
              placeholder="you@example.com"
              keyboardType="email-address"
              autoCapitalize="none"
            />
            <Button title="Send Reset Link" onPress={handleSubmit} loading={loading} />
          </>
        )}

        <View style={{ marginTop: 24, alignItems: "center" }}>
          <Link href="/(auth)/login/" asChild>
            <TouchableOpacity>
              <Text style={{ color: "#2563eb", fontSize: 14 }}>Back to sign in</Text>
            </TouchableOpacity>
          </Link>
        </View>
      </ScrollView>
    </KeyboardAvoidingView>
  );
}
